import {findKey, isEmpty} from 'lodash';
import {Fragment, useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {Icon, Select} from 'components';
import {DeviceKind} from 'enums';
import {TRANSLATION_KEYS} from 'locale';
import {mediaDevicesUtils} from 'utils';

const T_KEYS = TRANSLATION_KEYS.COMPONENTS.MEDIA_DEVICES_MODAL;

type Props = {
    type: MediaDeviceKind;
    selectedDeviceId: string;
    devices: MediaDeviceInfo[];
    children?: React.ReactNode;
    onDeviceChange: (deviceId: string) => void;
}

export const MediaDeviceWrapper: React.FC<Props> = ({type, selectedDeviceId, devices, children, onDeviceChange}) => {
    const {t} = useTranslation();
    const deviceNameTKey = useMemo(() => findKey(DeviceKind, (key) => key === type).toUpperCase(), [type]);

    const options = useMemo(() => mediaDevicesUtils.getDevicesOptions(type, devices), [type, devices]);

    return (
        <div className='tw-my-6'>
            {!isEmpty(options) ?
                <Fragment>
                    <Select
                        value={selectedDeviceId}
                        placeholder={t(T_KEYS.SOURCE)}
                        options={options}
                        valueAs='id'
                        onChange={onDeviceChange}
                    />
                    {children}
                </Fragment>
                :
                <div className='tw-flex tw-py-2 tw-px-4 tw-items-center'>
                    <Icon className='tw-mr-6' name='alert-triangle' size='4xl' color='default-dimmed' />
                    <div className='tw-ts-h5'>
                        <div>
                            {`${t(T_KEYS.DETECTION_FAILED_MESSAGE)} ${t(T_KEYS[deviceNameTKey] || T_KEYS.DEFAULT_DEVICE)}`}
                        </div>
                        <div>
                            {t(T_KEYS.CHECK_CONNECTION_MESSAGE)}
                        </div>
                    </div>
                </div>}
        </div>
    );
};